var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4045 1.33398L8.84827 5.45172L9.88047 3.025L14.4045 1.33398Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60095 1.33398L7.10223 5.49016L6.11947 3.025L1.60095 1.33398Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.406 10.8809L10.9291 13.1429L14.0915 14.0158L14.9919 10.9303L12.406 10.8809Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01343 10.9303L1.90835 14.0158L5.07076 13.1429L3.59936 10.8809L1.01343 10.9303Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90081 7.05946L4.01685 8.3881L7.15181 8.53086L7.04201 5.1543L4.90081 7.05946Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1048 7.06075L8.92515 5.11719L8.84827 8.53215L11.9832 8.38943L11.1048 7.06075Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07092 13.1437L6.9596 12.2268L5.33444 10.9531L5.07092 13.1437Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04041 12.2268L10.9291 13.1437L10.6655 10.9531L9.04041 12.2268Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9291 13.1434L9.04041 12.2266L9.18865 13.4564L9.17216 13.9725L10.9291 13.1434Z",
    fill: "#D5BFB2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07092 13.1434L6.8278 13.9725L6.81684 13.4564L6.9596 12.2266L5.07092 13.1434Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86065 10.1398L5.29041 9.67857L6.39945 9.16797L6.86065 10.1398Z",
    fill: "#233447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13928 10.1398L9.60048 9.16797L10.7205 9.67857L9.13928 10.1398Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07078 13.1429L5.34526 10.8809L3.59937 10.9303L5.07078 13.1429Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6545 10.8809L10.9291 13.1429L12.4059 10.9303L10.6545 10.8809Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9832 8.38867L8.84827 8.53143L9.13927 10.1401L9.60043 9.16831L10.7205 9.67891L11.9832 8.38867Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29061 9.67891L6.39965 9.16831L6.86085 10.1401L7.15181 8.53143L4.01685 8.38867L5.29061 9.67891Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01685 8.38867L5.33453 10.9527L5.29061 9.67891L4.01685 8.38867Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7203 9.67891L10.6654 10.9527L11.9831 8.38867L10.7203 9.67891Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15168 8.53125L6.86072 10.1399L7.22856 12.0395L7.30544 9.53597L7.15168 8.53125Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84819 8.53125L8.69995 9.53045L8.77131 12.0395L9.13919 10.1399L8.84819 8.53125Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13908 10.1389L8.77124 12.0385L9.04028 12.2252L10.6654 10.9515L10.7203 9.67773L9.13908 10.1389Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29041 9.67773L5.33433 10.9515L6.95948 12.2252L7.22849 12.0385L6.86065 10.1389L5.29041 9.67773Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17216 13.9716L9.18864 13.4555L9.0514 13.3347H6.9486L6.81684 13.4555L6.8278 13.9716L5.07092 13.1426L5.68584 13.6477L6.93212 14.5097H9.06788L10.3142 13.6477L10.9291 13.1426L9.17216 13.9716Z",
    fill: "#C0AC9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04033 12.2257L8.77129 12.0391H7.22853L6.95949 12.2257L6.81677 13.4556L6.94853 13.3348H9.05133L9.18857 13.4556L9.04033 12.2257Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.635 5.72076L15.1017 3.44775L14.4044 1.33398L9.04041 5.31448L11.1048 7.06036L14.0146 7.91136L14.657 7.1592L14.377 6.95608L14.8272 6.54976L14.4868 6.28076L14.9315 5.94584L14.635 5.72076Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.898193 3.44775L1.37036 5.72076L1.06839 5.94584L1.51311 6.28076L1.17271 6.54976L1.62291 6.95608L1.34291 7.1592L1.98527 7.91136L4.90062 7.06036L6.9595 5.31448L1.60095 1.33398L0.898193 3.44775Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0145 7.91155L11.1046 7.06055L11.9831 8.38923L10.6654 10.9532L12.4058 10.9312H14.9918L14.0145 7.91155Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90056 7.06055L1.98521 7.91155L1.01343 10.9312H3.59936L5.33428 10.9532L4.01664 8.38923L4.90056 7.06055Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84819 8.53021L9.04035 5.31289L9.88039 3.02344H6.11951L6.95951 5.31289L7.15167 8.53021L7.22307 9.54041L7.22855 12.0385H8.77131L8.77683 9.54041L8.84819 8.53021Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.ff3160c5a6796bf874014ce685486953.svg";
export { ForwardRef as ReactComponent };